/*
2026-06-04 ZD34079 Updated prices to remove trailing zeroes
*/


/* OPTIONAL: if (and only if) this file is actually rendered through Liquid somewhere,
   these will output values. If it’s a static asset, they’ll remain as literal text and be unused. */



import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  /* --- YOUR ORIGINAL CSS (unchanged) --- */
  .skio-plan-picker { display:flex; flex-direction:column; gap:10px; padding:0; border:0; margin-bottom:25px; }
  .skio-plan-picker.skio-cards{ gap:14px !important; margin-bottom:14px; }
  .skio-card{ border:2px solid rgba(0,0,0,.2); border-radius:12px; background:#fff; padding:18px; cursor:pointer; transition:all .2s ease; }
  .skio-card--selected{ border-color:#2c6b57; box-shadow:0 2px 14px rgba(44,107,87,.12); }
  .skio-card__header{ display:flex; align-items:center; gap:14px; }
  .skio-card__title{ font-size:22px; font-weight:700; line-height:1.2; margin:0; cursor:pointer; color:#2b2b2b; flex:1; }
  .skio-card__price{ margin-left:auto; display:flex; align-items:baseline; gap:12px; font-size:28px; font-weight:700; color:#2b2b2b; white-space:nowrap; }
  .skio-card__price-was{ font-size:28px; font-weight:600; color:#717171; text-decoration:line-through; }
  .skio-radio__container{ position:relative; display:flex; align-items:center; justify-content:center; width:24px; height:24px; flex:0 0 auto; }
  .skio-native-radio{ position:absolute; inset:0; opacity:0; width:24px; height:24px; margin:0; cursor:pointer; }
  .skio-radio-ui{ width:20px; height:20px; border:2px solid rgba(0,0,0,.35); border-radius:50%; display:block; position:relative; transition:all .2s ease; }
  .skio-native-radio:checked + .skio-radio-ui{ border-color:#2c6b57; border-width:2px; }
  .skio-native-radio:checked + .skio-radio-ui:after{ content:''; position:absolute; width:10px; height:10px; border-radius:50%; background:#2c6b57; left:50%; top:50%; transform:translate(-50%,-50%); }

  .skio-card__body{
    margin-top:0; overflow:hidden; max-height:0; opacity:0; transform:translateY(-4px);
    transition:max-height 360ms ease, opacity 300ms ease, transform 300ms ease, margin-top 300ms ease;
    will-change:max-height;
  }
  .skio-card__body.is-open{ margin-top:16px; max-height:600px; opacity:1; transform:none; }

  .skio-frequency{
    display:flex; align-items:center; gap:5px; padding:12px 40px 12px 16px; margin-bottom:8px;
    border-radius:6px; background-color:#f7f7f7; width:100%;
    border:1px solid rgba(0,0,0,.12); font-size:16px; font-family:inherit;
    white-space:nowrap; text-overflow:ellipsis;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position:right 12px top 50%; background-size:18px; background-repeat:no-repeat;
    appearance:none; -webkit-appearance:none; -moz-appearance:none; cursor:pointer;
  }
  .skio-frequency.skio-frequency--one{ background-image:none; pointer-events:none; }

  .skio-benefits.skio-benefits--plain{ margin:0; padding:0; list-style:none; }
  .skio-benefits.skio-benefits--plain li{ display:flex; align-items:center; gap:10px; margin-bottom:10px; font-size:16px; color:#2b2b2b; line-height:1.4; }
  .skio-benefits.skio-benefits--plain li:last-child{ margin-bottom:0; }
  .skio-benefits.skio-benefits--plain li svg{ flex-shrink:0; }

  .open-modal-btn{ text-decoration:underline; cursor:pointer; color:#537a78; }

  .getsunmed_pdp_susb_save_subs_onetime_left_lower_cta{
    margin:12px 0 0; text-decoration:underline; cursor:pointer; color:#2c6b57; font-weight:600;
  }

  .skio-card__body:has(.getsunmed_pdp_susb_save_subs_onetime_left_saving_copy) { display:flex; gap:8px; justify-content:start; align-items:center; }
  .skio-card__body:has(.getsunmed_pdp_susb_save_subs_onetime_left_saving_copy) > .getsunmed_pdp_susb_save_subs_onetime_left_saving_copy { margin:0; }
  .skio-card__body:has(.getsunmed_pdp_susb_save_subs_onetime_left_saving_copy) > .getsunmed_pdp_susb_save_subs_onetime_left_lower_cta { margin:0; }
  .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-46%) scale(.98);
    background: #fff;
    height: fit-content;
    max-width: 550px;
    width: 100%;
    border-radius: 0px;
    opacity: 0;
    transition: opacity .25s ease, transform .25s ease;
    overflow-y: auto;
    margin-top: 0px;
    -ms-scroll-chaining: none;
    overscroll-behavior: none;
    padding: 40px 30px 30px;
    border-radius: 8px;
    max-height: 88vh;
    }
    .skio-save-text {
        font-size: 14px;
    }
    .skio-frequency-group{
      display:flex;
      flex-direction:column;
      gap:10px;
      margin-bottom:16px;
    }

    .skio-frequency-group .label-text{
      font-family: Roboto, sans-serif;
      font-weight:500;
      font-size:13px;
      line-height:19.5px;
      letter-spacing:0;
      color:#305456;
      margin-bottom:0;
      margin-top:0px;
    }

    .skio-frequency-group-inner-wrap{
      display:flex;
      gap:8px;
      flex-wrap:wrap;
    }

    .skio-frequency-group-inner-wrap label.skio-frequency-radio{
      position:relative;
      border:1px solid #578B91;
      border-radius:4px;
      margin:0;
      padding:9px 15px;
      background:#F9FAFB;
      cursor:pointer;
      min-width:110px;
      justify-content:center;
      display:flex;
      align-items:center;
    }

    .skio-frequency-group-inner-wrap label.skio-frequency-radio input[type="radio"]{
      position:absolute;
      inset:0;
      width:100%;
      height:100%;
      opacity:0;
      cursor:pointer;
      margin:0;
    }

    .skio-frequency-group-inner-wrap label.skio-frequency-radio span.skio-frequency-label{
      font-family:Roboto, sans-serif;
      font-weight:600;
      font-size:14px;
      line-height:21px;
      letter-spacing:0;
      text-align:center;
      color:#305456;
    }

    .skio-frequency-group-inner-wrap label.skio-frequency-radio:has(input:checked){
      background:#305456;
    }

    .skio-frequency-group-inner-wrap label.skio-frequency-radio input:checked + span.skio-frequency-label{
      color:#fff;
    }
  @media (max-width:767px){
    .skio-card{ padding:14px; }
    .skio-card__title{ font-size:18px; }
    .skio-card__price{ font-size:20px; flex-direction:column; gap:0; align-items:flex-end; }
    .skio-card__price-was{ font-size:16px; }
    .skio-frequency{ font-size:15px; padding:10px 36px 10px 14px; }
    .skio-benefits.skio-benefits--plain li{ font-size:14px; }
    .model-main-wrap{ max-width:100%; border-radius:0; padding:0; }
    button.model-close-btn::before{ font-size:16px; text-transform:uppercase; position:relative; top:1px; }
    button.model-close-btn{
      position:relative; top:unset; left:unset; right:unset; height:50px; box-shadow:0 3px 4px rgba(0,0,0,.25);
      width:100%; padding:10px; margin-left:auto; color:#000; font-size:20px; border:none; background:none;
      display:flex; align-items:center; justify-content:center; gap:10px;
      font-family:var(--typeBasePrimary),var(--typeBaseFallback);
      letter-spacing:var(--typeBaseSpacing); line-height:var(--typeBaseLineHeight); font-weight:bold;
    }
    .model-wrap .model-main-wrap .content-wrap{ padding:40px 30px 30px; }
    button.end-close-btn{ font-size:13px; width:100%; padding:13px 33px; }
    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap .content-wrap p{ font-size:15px; }
    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
        padding: 0px 30px 30px;
        max-height: 95vh;
    }
    .getsunmedpdpsusbsavesubsinfocontent.model-wrap .model-main-wrap .content-wrap {
        padding: 10px 10px 10px;
    }
  }
  .discount-announcement--content {
    display: flex;
    gap: 5px;
    justify-content: center;
    font-weight: 500;
    color: #f8f8f8ff;
    background: linear-gradient(180deg, #b8860b 0%, #cd853f 50%, #daa520 100%);
    border: solid #8d5c2d 1px;
    border-radius: 7px;
    margin: 0 0 10px auto;
    padding: 2px 10px;
    width: fit-content;
    max-width: 100%;

    p {
      margin: 0px;
    }
  }
  .discount-announcement--check {
      opacity: 0;
      animation: checkMark 3s ease-out 4.5s forwards;
      align-self: center;
  }
  @keyframes checkMark {
      0% {
          -webkit-transform: scale(0);
          transform: scale(0);
      }
      5%, 20%, 90%, 100% {
          opacity: 100; 
          -webkit-transform: scale(1) rotate(0deg);
          transform: scale(1) rotate(0deg);
      }
      10% {
          -webkit-transform: scale(1.2) rotate(20deg);
          transform: scale(1.2) rotate(20deg);
      }
      15% {
          -webkit-transform: scale(1.2) rotate(-20deg);
          transform: scale(1.2) rotate(-20deg);
      }
  }
  .hide { display:none; }

  
    .wrap-message-before {

        width: calc(100% - 59px);
        display: flex;
    }

    .wrap-message-before .open-modal-btn {
      display: block;
      width: 100%;
      text-align: center;
      text-decoration: none;
      cursor: pointer;
      color: #62908E;
      font-family: Roboto, sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.3;
      padding: 12px 16px;
      border: 1px solid #62908E;
      border-radius: 4px;
      background: #fff;
    }

    .wrap-message-before .open-modal-btn b {
      font-weight: 900;
    }

   .swym-proxy-button {
      margin-top: 12px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      border: 1px solid #305456;
      border-radius: 4px;
      background: #fff;
      color: #305456;
      padding: 14px 18px;
      cursor: pointer;
      font-size: 24px;
      font-family: Roboto, sans-serif;
      font-weight: 900;
      letter-spacing: 0.5px;
    }

    .swym-proxy-button-text {
      font-size: 24px;
      font-family: Roboto, sans-serif;
      font-weight: 900;
      letter-spacing: 0.5px;
    }

    .swym-proxy-button-icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }

    .swym-proxy-button.atw-button-added svg{

    }

    .swym-proxy-button.atw-button-added svg path{
      fill:#334848;
      strock:#334848;
    }

    .swym-proxy-button.atw-button-added .swym-proxy-button-text{
      color: #334848;
    }


    .swym-proxy-button svg path{
        transition:all 300ms;
    }

    .swym-proxy-button .swym-proxy-button-text{
      transition:all 300ms;
    }

    .swym-proxy-button:hover svg path{
      scale:1.01;
    }

    .swym-proxy-button:hover .swym-proxy-button-text{
      scale:1.01;
    }


      .d-flex-wrap-w-m {
    display: flex;
    margin-top: 16px;
        gap: 10px;
}

.wrap-message-before .open-modal-btn {
    background: linear-gradient(180deg, #b8860b 0%, #cd853f 50%, #daa520 100%);
    border: none;
    border-radius: 4px;
    padding: 9px 24px;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
    text-decoration: none;
    text-align: center;
    letter-spacing: 0px;
    justify-content: center;
    align-items: center;
    border: 3px solid #000;
    line-height: 1.3;
    flex-direction: column;
    font-size: 17px;
    display: flex;
    width: 100%;
    font-family: Roboto;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: Static/Body Large/Line Height;
    letter-spacing: 0%;
}

button.swym-proxy-button {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding:0px;
    border:none;
    width:59px;
        margin-top: 0px;
}

button.swym-proxy-button svg.swym-proxy-button-icon {
    width: 24px;
    height: 24px;
}

button.swym-proxy-button span.swym-proxy-button-text {
    font-size: 10px;
    line-height: 10px;
    color: #334848;
    font-family: Roboto, sans-serif;
    font-weight: 900;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}
.gaurantee-Back-tag  button.model-close-btn::before {
        content: none;
}
    .skio-card__header.one-time .skio-card__price {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .atc-price-display {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 20px;
      font-weight: 500;
    }
    .atc-save-btn {
        font-size: 12px;
        font-weight: 300;
        letter-spacing: 0.3px;
    }
          .gaurantee-Back-tag .model-main-wrap {
              border-radius: 12px;
              position: relative;
              padding-top: 12px;
          }
          .gaurantee-Back-tag .model-main-wrap::before {
              content: "";
              position: absolute;
              height: 12px;
              width: 100%;
              background-image:  linear-gradient(90deg, #CD853F 100%, #DAA520 50%, #8D673D 0%);
              left: 0;
              top: 0px;
              z-index: 15;
              border-radius: 12px 12px 0px 0px;
          }
.gaurantee-Back-tag button.model-close-btn {
    position: sticky;
    right: 12px !important;
    top: 23px !important;
    height: 17px !important;
    background: transparent !important;
    font-weight: 400;
}  
  @media (max-width:767px) {
  .d-flex-wrap-w-m {
        margin-top: 0px;
  }
  .skio-card__body.is-open.mobile-add-to-cart-section {
      margin-top: 0px;
  }
  .model-wrap.gaurantee-Back-tag .model-main-wrap .content-wrap {
    padding:20px 30px 0px;
  }
  .model-wrap.gaurantee-Back-tag button.end-close-btn {
                   margin-bottom: 35px;
  }
  button.model-close-btn-mob {
    display:block;
    position: absolute !important;
    top: 0px !important;
    right: 10px !important;
    background: none !important;
    border: none !important;
    font-size: 30px !important;
    z-index: 122;
    box-shadow: none !important;
    width: fit-content !important;
    padding: 0px !important;
    height:unset;
}
  button.model-close-btn.desk {
      display: none;
  }
  button.model-close-btn-mob {
      position: absolute;
      top: 10px;
      right: 0;
      background: none;
      border: none;
  }
    .skio-card__title { font-size:18px; }
    .skio-card__price { font-size:20px; }
    .skio-card__price-was { font-size:16px; }
    .skio-frequency-group { gap:8px; }
    .skio-frequency-radio { font-size:15px; }
    .skio-benefits.skio-benefits--plain li { font-size:14px; }
    .skio-onetime-copy { font-size:14px; }
    .skio-atc { font-size:16px; padding:16px 20px; }

    .model-main-wrap { max-width:100%; border-radius:0; padding:0; }

    button.model-close-btn::before {
      content:"CLOSE";
      font-size:16px;
      text-transform:uppercase;
      position:relative;
      top:1px;
    }

    button.model-close-btn {
      position: sticky;
      top: 0px;
      background: #fff !important;
      left:unset;
      right:unset;
      height:50px;
      box-shadow:0 3px 4px rgba(0,0,0,.25);
      width:100%;
      padding:10px;
      margin-left:auto;
      color:#000;
      font-size:20px;
      border:none;
      background:none;
      display:flex;
      align-items:center;
      justify-content:center;
      gap:10px;
      font-family:var(--typeBasePrimary),var(--typeBaseFallback);
      letter-spacing:var(--typeBaseSpacing);
      line-height:var(--typeBaseLineHeight);
      font-weight:bold;
    }
      .wrap-message-before .open-modal-btn {
          padding: 5px 24px;
      }

    .model-wrap .model-main-wrap .content-wrap { padding:40px 30px 30px; }
    button.end-close-btn { font-size:13px; width:50%; padding:13px 33px;margin-bottom: 50px;}
    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap .content-wrap p { font-size:15px; }

    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
      padding:0 30px 100px;
        
    }
   /* Parent overlay — add flexbox centering */
    .getsunmedpdpsusbsavesubsinfocontent.model-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px; /* prevents modal touching screen edges on small screens */
    }

    /* Modal — remove absolute positioning and top/left entirely */
    .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
        position: relative;
        left: auto;
        top: auto;
        transform: scale(0.95);
        background: #fff;
        height: fit-content;
        max-width: 550px;
        width: 100%;
        opacity: 0;
        transition: opacity .25s ease, transform .25s ease;
        overflow-y: auto;
        margin-top: 0;
        -ms-scroll-chaining: none;
        overscroll-behavior: none;
        padding: 0px 0px 0px;
        border-radius: 0px;
        max-height: 88vh;
    }

    /* Open state — only scale and opacity change, no position shift */
    .model-wrap.is-open.getsunmedpdpsusbsavesubsinfocontent .model-main-wrap {
        transform: scale(1);
        opacity: 1;
    }
    .getsunmedpdpsusbsavesubsinfocontent.model-wrap .model-main-wrap .content-wrap {
      padding:10px 10px 10px;
    }

    .outer-delivey-text > svg {
      position: relative;
      top: 4px;
    }

    span.outer-delivey-text {
      text-align: start;
      position: relative;
      top: -2px;
    }
      
  }
  /* Desktop button adjustments */
@media (min-width: 768px) {

  /* increase space between buttons */
  .d-flex-wrap-w-m{
    gap:16px;
  }

  /* make "See this before you buy" 20% shorter */
  .wrap-message-before{
    width: calc(100% - 75px);
  }

  /* make shortlist button slightly wider */
  button.swym-proxy-button{
    width:75px;
  }
}
  
  .skio-atc {
    margin-top:16px;
    width:100%;
    border:none;
    border-radius:8px;
    padding:14px 18px;
    font-size:16px;
	  letter-spacing: 0.7px;
    font-weight: 450;
    cursor:pointer;
    transition:all .2s ease;
    font-family:inherit;
	  display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .skio-atc:hover {
    opacity:.95;
  }

  .skio-atc--subscription {
        background: #305456;
        color: #fff;
        border-radius: 4px;
        height: 80px;
        flex-direction: column;
        gap: 10px;
    }
    .skio-atc--subscription > p {
        font-family: Roboto;
        font-weight: 700;
        font-style: Bold;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 24px;
        letter-spacing: 0%;
        text-align: center;
        color: #fff;
        margin: 0px;
        text-transform: uppercase;
    }

    .skio-atc--subscription > span {
        font-family: Roboto;
        font-weight: 900;
        font-style: Black;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 11.43px;
        letter-spacing: 0.6px;
        text-align: center;
        vertical-align: middle;
        text-transform: uppercase;
        color: #E8BC69;
    }
  .skio-atc--onetime {
    background:#f5f5f5;
    color:#2b2b2b;
    border:1px solid rgba(0,0,0,.12);
  }
   .no-padding {
    margin: 0 !important;
  }

  @media(min-width: 769px) {
    .mobile-add-to-cart-section {
      display: none !important;
    }
  }
  @media (max-width:768px){
    .skio-card__body.is-open.mobile-add-to-cart-section:has(.model-wrap.gaurantee-Back-tag.is-open) {
        margin-top: 0px;
        max-height: 600px;
        opacity: 1;
        transform: none;
        overflow: unset;
        max-height: unset;
    }
    .gaurantee-Back-tag .model-close-btn {
        display: none;
    }
    .gaurantee-Back-tag button.model-close-btn.model-close-btn-mob {
        display: block;
        top: 10px !important;
    }
    .gaurantee-Back-tag .model-main-wrap {
      width: 96%;    
    }    
  } 
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },
    productHandle: { type: String },
    key: { type: String },
    formId: { type: String },
    needsFormId: { type: Boolean },
    subscriptionFirst: { type: Boolean },
    startSubscription: { type: Boolean },
    discountFormat: { type: String },
    currency: { type: String },
    language: { type: String },
    moneyFormatter: {},
    externalPriceSelector: { type: String },
    externalPriceSelectorWithCurrency: { type: String },
    externalSaveSelector: { type: String },
    selectedVariant: { type: Object },
    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},
    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},
    defaultFrequency: {},
    useVariantInputClickEvents: { type: Boolean },
    variantInputSelector: {}
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;
    this.productHandle = null;

    this.purchaseOption = 'onetime';
    this.key = null;

    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.discountFormat = 'percent';
    this.externalPriceSelector = '[skio-external-price]';
    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';
    this.externalSaveSelector = '[skio-external-save]';

    this.currency = Shopify?.currency?.active || 'USD';
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, { style: 'currency', currency: this.currency, trailingZeroDisplay: "stripIfInteger" });

    this.defaultFrequency = null;
    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;

    this.skioUiInitialized = false;

    this.modalHandlersBound = false;
    this.modalStackCount = 0;
    this.BASE_Z_INDEX = 10000;
    this.Z_INCREMENT = 1001;
    this.onModalRootClick = null;
    this.onModalRootCloseClick = null;

    this.isIntialLoad = true;

    this.modalMap = {
      'getsunmedpdpsusbsavesubsinfocontent': 'getsunmedpdpsusbsavesubsinfocontent'
    };
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription === true) this.purchaseOption = 'subscription';

    if (!this.product && this.productHandle) this.fetchProduct(this.productHandle);

    if (this.needsFormId && this.formId == null) {
      const forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key') && el.getAttribute('skio-key') == this.key) form = el;
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }

    const skio = this;
    document.addEventListener("variantChanged", function(e) {
      const variantId = e?.detail?.variantId;
      if (!variantId || !skio.product?.variants) return;
      const variant = skio.product.variants.find(x => String(x.id) === String(variantId));
      if (variant) skio.selectedVariant = variant;
      skio.requestUpdate();
    });

    if (this.useVariantInputClickEvents) {
      document.addEventListener('load', skio.addVariantClickEventListeners);
    }
  }

  firstUpdated() {
    this.bindModalHandlers();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.unbindModalHandlers();
  }

  bindModalHandlers() {
    if (this.modalHandlersBound) return;
    this.modalHandlersBound = true;

    this.onModalRootClick = (e) => {
      const trigger = e.target?.closest?.('.open-modal-btn, .scrolling-text');
      if (!trigger) return;

      const triggerId = trigger.id;
      const targetClass = this.modalMap?.[triggerId] || triggerId;
      const modal = this.renderRoot.querySelector(`.model-wrap.${CSS.escape(targetClass)}`);
      if (!modal) return;

      e.preventDefault();
      this.openModal(modal);
    };

    this.onModalRootCloseClick = (e) => {
      const btn = e.target?.closest?.('.model-close-wrap, .model-close-btn, .end-close-btn');
      if (!btn) return;

      const modal = btn.closest('.model-wrap');
      if (!modal) return;

      e.preventDefault();
      this.closeModal(modal);
      document.querySelector('#shopify-section-header').classList.remove('go-be');
    };

    this.renderRoot.addEventListener('click', this.onModalRootClick);
    this.renderRoot.addEventListener('click', this.onModalRootCloseClick);
  }

  unbindModalHandlers() {
    if (!this.modalHandlersBound) return;
    this.modalHandlersBound = false;

    if (this.onModalRootClick) this.renderRoot.removeEventListener('click', this.onModalRootClick);
    if (this.onModalRootCloseClick) this.renderRoot.removeEventListener('click', this.onModalRootCloseClick);

    this.onModalRootClick = null;
    this.onModalRootCloseClick = null;
  }

  _getHideWhySubscribe() {
    if (typeof window !== 'undefined' && window.__HIDE_WHY_SUBSCRIBE__ !== undefined) return window.__HIDE_WHY_SUBSCRIBE__;
    try { return null; } catch(e) { return false; }
  }

  _getWhySubscribeHtml() {
    const mf = (window.__WHY_SUBSCRIBE_TEXT__ || '').toString().trim();
    if (mf) return mf;

    return (window.__WHY_SUBSCRIBE_DEFAULT_HTML__ || '').toString().trim();
  }


  _escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  _mountWhyHtmlIntoModal() {
    const mount = this.renderRoot.querySelector('[data-why-html-mount]');
    if (!mount) return;

    const raw = (this._getWhySubscribeHtml() || '').toString().trim();

    if (!raw) {
      mount.innerHTML = '';
      mount.style.display = 'none';
      return;
    }

    // Show it
    mount.style.display = '';

    // If merchant stored HTML (<p>, <br>, <img>...), render as-is
    const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
    if (looksLikeHtml) {
      mount.innerHTML = raw;
      return;
    }

    // Otherwise: treat as plain text and format into paragraphs
    const parts = raw
      .split(/\r?\n\s*\r?\n|\r?\n/g)
      .map(s => s.trim())
      .filter(Boolean);

    mount.innerHTML = parts.map(t => `<p>${this._escapeHtml(t)}</p>`).join('');
  }

  openModal(modal) {
    if (!modal) return;

    this.modalStackCount++;
    const currentZ = this.BASE_Z_INDEX + this.modalStackCount * this.Z_INCREMENT;

    modal.classList.add('is-open');
    modal.style.zIndex = String(currentZ);

    // Inject HTML after modal is open
    this._mountWhyHtmlIntoModal();

    document.documentElement.style.overflow = 'hidden';

    const mars = document.querySelector('#marsello-widget-root');
    if (mars) mars.style.setProperty('z-index', '99999999999999', 'important');

    const pc = document.querySelector('#PageContainer');
    if (pc) {
      pc.style.position = 'relative';
      pc.style.zIndex = String(999999999999999);
    }

    // const atc = document.querySelector('.btn-add-to-card-wrap');
    // if (atc) atc.style.setProperty('z-index', '10', 'important');
  }

  closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.style.zIndex = '';

    if (this.modalStackCount > 0) this.modalStackCount--;

    const anyOpen = this.renderRoot.querySelector('.model-wrap.is-open');
    if (!anyOpen) {
      const mars = document.querySelector('#marsello-widget-root');
      if (mars) mars.removeAttribute('style');

      const pc = document.querySelector('#PageContainer');
      if (pc) pc.removeAttribute('style');

      setTimeout(() => {
        const stillOpen = !!this.renderRoot.querySelector('.model-wrap.is-open');
        if (!stillOpen) {
          document.documentElement.style.overflow = '';
          this.modalStackCount = 0;
        }
      }, 260);

      // const atc = document.querySelector('.btn-add-to-card-wrap');
      // if (atc) atc.removeAttribute('style');
    }
  }

  openModalByTriggerId(triggerId) {
    const targetClass = this.modalMap?.[triggerId] || triggerId;
    const modal = this.renderRoot.querySelector(`.model-wrap.${CSS.escape(targetClass)}`);
    if (!modal) return;
    this.openModal(modal);
    document.querySelector('#shopify-section-header').classList.add('go-be');
  }
  
  validateShipToState() {
    const stateInput = document.querySelector('#shipToStateInputContainer input');
    if (!stateInput) return true;

    const value = stateInput.value?.trim();
    if (value) return true;

    const container = document.querySelector('#shipToStateInputContainer') || stateInput;

    container.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    setTimeout(() => {
      stateInput.focus();

      stateInput.dispatchEvent(new Event('input', { bubbles: true }));
      stateInput.dispatchEvent(new Event('change', { bubbles: true }));
      stateInput.dispatchEvent(new Event('blur', { bubbles: true }));

      const form = stateInput.form || stateInput.closest('form');
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      }
    }, 300);

    return false;
  }

  syncSwymButtonState() {
    const proxyBtn = this.renderRoot?.querySelector('.swym-proxy-button');
    const realBtn = document.querySelector('#swym-atw-pdp-button');

    if (!proxyBtn) return;

    if (!realBtn) {
      proxyBtn.classList.remove('atw-button-added');
      return;
    }

    proxyBtn.classList.toggle(
      'atw-button-added',
      realBtn.classList.contains('atw-button-added')
    );
  }

  async submitAddToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      let errorMessage = 'Failed to add to cart';
      try {
        const errorData = await response.json();
        errorMessage = errorData?.description || errorData?.message || errorMessage;
      } catch (e) {}
      throw new Error(errorMessage);
    }

    return response.json();
  }

  async openCartDrawerOrRefresh() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

      const cartDrawerTriggers = [
        '[data-drawer-open-btn]',
        '[data-cart-toggle]',
        '.js-drawer-open-cart',
        '.site-header__cart',
        '.header-cart',
        '[href="/cart"]'
      ];

      for (const selector of cartDrawerTriggers) {
        const el = document.querySelector(selector);
        if (el && selector !== '[href="/cart"]') {
          el.click();
          return;
        }
      }
    } catch (e) {
      console.warn('Cart UI refresh failed', e);
    }
  }

  async submitSubscriptionOrOneTime() {
    if (!this.validateShipToState()) return;

    try {
      const variantId = this.selectedVariant?.id;
      if (!variantId) return;

      if (this.purchaseOption == 'subscription') {
        const group = this.availableSellingPlanGroups?.[0] || null;
        if (!group) throw new Error('No subscription group found');

        const sellingPlan = group.selected_selling_plan || group.selling_plans?.[0] || null;

        if (!sellingPlan?.id) {
          this.selectedSellingPlanGroup = null;
          this.selectedSellingPlan = null;
          this.purchaseOption = 'onetime';

          await this.submitAddToCart([
            {
              id: variantId,
              quantity: 1
            }
          ]);
        }

        group.selected_selling_plan = sellingPlan;
        this.selectedSellingPlanGroup = group;
        this.selectedSellingPlan = sellingPlan;
        this.purchaseOption = 'subscription';

        this.updateExternalPrice();
        this.requestUpdate();

        await this.submitAddToCart([
          {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlan.id,
            properties: {
              Discount: this.discount(sellingPlan).percent
            }
          }
        ]);
      } else {
        this.selectedSellingPlanGroup = null;
        this.selectedSellingPlan = null;
        this.purchaseOption = 'onetime';

        await this.submitAddToCart([
          {
            id: variantId,
            quantity: 1
          }
        ]);
      }

      await this.openCartDrawerOrRefresh();
    } catch (error) {
      console.error('Add to cart failed:', error);
      alert(error.message || 'Unable to add to cart');
    }
  }
  
  getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
      }
      return "";
  }
  
  render() {
    if (!this.product || !this.selectedVariant) return;

    const hideWhySubscribe = this._getHideWhySubscribe();
    const rawWhy = (this._getWhySubscribeHtml() || '').toString().trim();
    const hasWhy = rawWhy.length > 0;

    const defaultWhySubscribeLines = [
      `Meditation doesn’t transform us in a day — it takes about 8 weeks of consistent practice before the real benefits appear.`,
      `The same’s true for ${this.product?.title || ''} — our bodies need time to respond.`,
      `We’ve worked with thousands who take ${this.product?.title || ''}.`,
      `Those who take it for a few months see better results — much better results than those who try it for a few weeks.`
    ].filter(Boolean);

    // ✅ FIX 1: If metafield has content, do NOT render default block.
    // ✅ FIX 2: Metafield is injected into this mount (innerHTML) on openModal().
    const whySubscribeContent = hasWhy
      ? html`<div class="content-wrap" data-why-html-mount></div>`
      : html`
          <div class="content-wrap">
            ${defaultWhySubscribeLines.map((t) => html`<p>${t}</p>`)}
          </div>
        `;

    const subscriptionGroup = this.availableSellingPlanGroups?.[0] || null;
    const plans = subscriptionGroup?.selling_plans || [];
    const selectedPlan = subscriptionGroup?.selected_selling_plan || null;

    const oneTimePriceRaw = this.selectedVariant.price;
    const subscriptionPriceRaw = selectedPlan ? this.price(selectedPlan, false) : this.selectedVariant.price;

    const oneTimePrice = this.moneyFormatter.format(oneTimePriceRaw / 100);
    const subscriptionPrice = this.moneyFormatter.format(subscriptionPriceRaw / 100);
    const savingAmount = this.money(oneTimePriceRaw - subscriptionPriceRaw);

    const isSubscription = !!this.selectedSellingPlanGroup;
	
	    const discountCode = getCookie('discount_code');


    const onSelectSubscription = (e) => {
      if (e?.target?.closest?.('.open-modal-btn')) return;
      e.preventDefault();
      e.stopPropagation();
      if (!subscriptionGroup) return;
      this.selectSellingPlanGroup(subscriptionGroup);
      this.requestUpdate();
    };

    const onSelectOnetime = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.selectSellingPlanGroup(null);
      this.requestUpdate();
    };

    const checkSvg = html`
      <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="9.05" r="8.5" fill="#305456"></circle>
        <path d="M4.5 9.05L7 12.05L12.5 7.05" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    const planDays = selectedPlan
      ? (plan => {
          if (plan.name === 'Every 1 Month') return 30;
          if (plan.name === 'Every 2 Months') return 60;
          if (plan.name === 'Every 3 Months') return 90;
          // Fallback: parse the first number in the name
          const match = String(plan.name).match(/\d+/);
          return match ? parseInt(match[0], 10) * 30 : 30;
        })(selectedPlan)
      : 30;

    return html`
      <fieldset class="skio-plan-picker skio-cards" skio-plan-picker="${this.key}">
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="selling_plan" type="hidden" value="${this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ''}" />
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="properties[Discount]" type="hidden"
          value="${this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : ''}"
          ?disabled="${this.selectedSellingPlan == null}" />

        <div class="skio-card ${isSubscription ? 'skio-card--selected ' : ''}${this.availableSellingPlanGroups?.length <= 0 ? 'hide' : ''}" @click=${onSelectSubscription}>
          <div class="skio-card__header">
            <div class="skio-radio__container">
              <input
                id="skio-subscribe-${this.key}"
                class="skio-native-radio"
                name="skio-purchase-option-${this.key}"
                type="radio"
                value="subscription"
                .checked=${isSubscription}
                @click=${(e) => e.stopPropagation()}
                @change=${onSelectSubscription}
              />
              <span class="skio-radio-ui" aria-hidden="true"></span>
            </div>

            <label class="skio-card__title" for="skio-subscribe-${this.key}">
              Subscribe <small style="font-size: 22px;">&</small> Save ${this.discountFormat == 'percent' ? this.discount(selectedPlan).percent : this.discount(selectedPlan).amount}
            </label>

            <div class="wrap-skio-card__price_save">
              <div class="skio-card__price">
                <span class="skio-card__price-now">${this.price(selectedPlan)}</span>
                <span class="skio-card__price-was">${this.moneyFormatter.format(this.selectedVariant.price / 100)}</span>
              </div>
              <div class="skio-save-text">
              Your saving is ${savingAmount} (${this.discountFormat == 'percent' ? this.discount(selectedPlan).percent : this.discount(selectedPlan).amount})
              </div>
            </div>
          </div>

          <div class="skio-card__body is-open" @click=${(e) => e.stopPropagation()}>
            <div class="skio-frequency-group">
              <p class="label-text">Delivery frequency</p>
              <div class="skio-frequency-group-inner-wrap">
                ${plans.map((plan) => html`
                  <label class="skio-frequency-radio">
                    <input
                      type="radio"
                      name="skio-frequency-${this.key}"
                      value="${plan.id}"
                      ?checked=${selectedPlan?.id == plan.id}
                      @change=${(e) => subscriptionGroup && this.selectSellingPlan(e.target, subscriptionGroup)}
                    />
                    <span class="skio-frequency-label">
                      ${plan.name === 'Every 1 Month'
                        ? '30 days'
                        : plan.name === 'Every 2 Months'
                        ? '60 days'
                        : plan.name === 'Every 3 Months'
                        ? '90 days'
                        : plan.name}
                    </span>
                  </label>
                `)}
              </div>
            </div>            
            <ul class="skio-benefits skio-benefits--plain">
              <li>${checkSvg}Lock in your discount for life</li>
              ${!hideWhySubscribe ? html`
                <li>
                  ${checkSvg}
                  <span
                    class="open-modal-btn"
                    id="getsunmedpdpsusbsavesubsinfocontent"
                    @click=${(e) => { e.preventDefault(); e.stopPropagation(); this.openModalByTriggerId('getsunmedpdpsusbsavesubsinfocontent'); }}
                  >Why subscribe?</span>
                  <span>←</span>
                  <span>Click</span>
                </li>
              ` : html``}
              <li>${checkSvg}Delivery every ${planDays} days. ⏸️ or 🛑 with one click at any time.</li>
              <li>${checkSvg}30-day money back guarantee</li>
            </ul>
          </div>
        </div>

        <div class="skio-card ${!isSubscription ? 'skio-card--selected' : ''}" @click=${onSelectOnetime}>
          <div class="discount-announcement--content ${discountCode == '' ? ' hide' : ''}">
            <p>Coupon applied. See discount in cart.</p>
            <p class="discount-announcement--check">✓</p>
          </div>
		  <div class="discount-announcement--content ${this.selectedVariant.metafields?.discount_pdp_copy ? '' : ' hide'}">
		    <p>${this.selectedVariant.metafields?.discount_pdp_copy} - ${this.selectedVariant.metafields?.discount_percentage * 100}% off applied</p>
		  </div>
          <div class="skio-card__header">
            <div class="skio-radio__container">
              <input
                id="skio-one-time-${this.key}"
                class="skio-native-radio"
                name="skio-purchase-option-${this.key}"
                type="radio"
                value="onetime"
                .checked=${!isSubscription}
                @click=${(e) => e.stopPropagation()}
                @change=${onSelectOnetime}
              />
              <span class="skio-radio-ui" aria-hidden="true"></span>
            </div>

            <label class="skio-card__title" for="skio-one-time-${this.key}">One time purchase</label>

            <div class="skio-card__price">
              <span class="skio-card__price-now">${this.selectedVariant.metafields?.auto_discounted_price ? this.moneyFormatter.format(this.selectedVariant.metafields.auto_discounted_price / 100) : this.moneyFormatter.format(this.selectedVariant.price / 100)}</span>
              <span class="skio-card__price-was">${this.selectedVariant.metafields?.auto_discounted_price ? this.moneyFormatter.format(this.selectedVariant.price / 100) : ""}</span>
            </div>
          </div>

          ${(!isSubscription && subscriptionGroup) ? html`
            <div class="skio-card__body is-open">
              <p class="getsunmed_pdp_susb_save_subs_onetime_left_saving_copy">
                Want to save ${this.discountFormat == 'percent' ? this.discount(selectedPlan).percent : this.discount(selectedPlan).amount}?
              </p>
              <p
                class="getsunmed_pdp_susb_save_subs_onetime_left_lower_cta"
                @click=${(ev) => {
                  ev.preventDefault();
                  ev.stopPropagation();
                  this.selectSellingPlanGroup(subscriptionGroup);
                  this.requestUpdate();
                }}
              >Switch to subscription</p>
            </div>
          ` : html``}
        </div>

        <div class="model-wrap getsunmedpdpsusbsavesubsinfocontent">
          <div class="model-close-wrap" style="display: none;"></div>
          <div class="model-main-wrap">
            <button class="model-close-btn">✕</button>
            ${whySubscribeContent}
            <button class="end-close-btn">CONTINUE</button>
          </div>
        </div>

        <div class="skio-card__body is-open mobile-add-to-cart-section">
            <div class="d-flex-wrap-w-m">
              <div class="wrap-message-before">
                <span
                  class="open-modal-btn"
                  id="gaurantee-Back-tag"
                  @click=${(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openModalByTriggerId('gaurantee-Back-tag');
                  }}
                >
                  SEE THIS <br>
                  <b>BEFORE YOU BUY</b>
                </span>

                <div class="model-wrap gaurantee-Back-tag">
                  <div class="model-close-wrap" style="display: none;"></div>
                  <div class="model-main-wrap">
                    <button class="model-close-btn">CLOSE X</button>
                    <button class="model-close-btn model-close-btn-mob">×</button>
                    <div class="content-wrap">

                          <p>The only way to get someone to buy again is by making something that <b>actually works.</b></p>
                          <p>Broad Spectrum Allergy Aid CBD Pet Chews works.</p>
                          <p>And if I'm wrong, I'll personally send you full refund.</p>
                          <button class="end-close-btn">CONTINUE</button>
                      </div>
                  </div>
                </div>
              </div>

              <button
                type="button"
                class="swym-proxy-button"
                @click=${(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const realSwymButton = document.querySelector('#swym-atw-pdp-button');
                  if (realSwymButton) {
                    realSwymButton.click();
                    setTimeout(() => this.syncSwymButtonState(), 50);
                  }
                }}
              >
                <svg class="swym-proxy-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                  <path d="M5 6.2C5 5.07989 5 4.51984 5.21799 4.09202C5.40973 3.71569 5.71569 3.40973 6.09202 3.21799C6.51984 3 7.07989 3 8.2 3H15.8C16.9201 3 17.4802 3 17.908 3.21799C18.2843 3.40973 18.5903 3.71569 18.782 4.09202C19 4.51984 19 5.07989 19 6.2V21L12 16L5 21V6.2Z" stroke="#334848" stroke-width="1.75" fill="none" stroke-linejoin="round"></path>
                </svg>
                <span class="swym-proxy-button-text">Shortlist</span>
              </button>
            </div>

            <button
              type="button"
              class="skio-atc skio-atc--subscription"
              @click=${async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await this.submitSubscriptionOrOneTime();
              }}
            >
              <span class="add-to-cart">Add to cart</span>
              <span class="moneyback_text">30 Day Money Back Guarantee</span>
            </button>
          </div>

        <style>
          .model-wrap{position:fixed;inset:0;display:block;opacity:0;visibility:hidden;transition:opacity .4s ease-in, visibility .4s ease-in;z-index:999999999999}
          .model-wrap.is-open{opacity:1;visibility:visible}
          .model-close-wrap{position:absolute;inset:0;background:rgba(0,0,0,.5);opacity:0;transition:opacity .4s ease-in;display:none}
          .model-wrap.is-open .model-close-wrap{display:block !important;opacity:1}
          .model-main-wrap{position:absolute;left:50%;top:50%;transform:translate(-50%,-46%) scale(.98);background:#fff;height:fit-content;max-width:440px;width:100%;border-radius:0px;opacity:0;transition:opacity .25s ease, transform .25s ease;overflow-y:auto;margin-top:0px;-ms-scroll-chaining:none;overscroll-behavior:none;padding:40px 30px 30px;border-radius:8px}
          .model-wrap.is-open .model-main-wrap{opacity:1;transform:translate(-50%,-50%) scale(1)}
          .model-close-btn,.end-close-btn,.open-modal-btn{cursor:pointer}
          button.model-close-btn{position:absolute;right:6px;top:4px;box-shadow:none;color:transparent;width:40px;height:40px;padding:10px;margin-left:auto;display:block;font-size:20px;border:none;background:none}
          button.model-close-btn:before{content:'✕';color:#000;font-size:24px}
          button.end-close-btn{background-color:#305456;color:#fff;border:none;border-radius:2px;padding:10px 33px;font-size:16px;font-weight:500;text-transform:uppercase;cursor:pointer;display:block;margin-left:auto;margin-right:auto;margin-top:30px;font-family:var(--typeBasePrimary,var(--typeBaseFallback))}
          .getsunmedpdpsusbsavesubsinfocontent .model-main-wrap .content-wrap p{color:#000;font-size:18px;line-height:1.5;margin:0 0 20px;text-align:left}
          .skio-atc.skio-atc--subscription .add-to-cart { color: #FFF; font-weight: 900; letter-spacing: 0.5px; font-size: 24px; white-space: nowrap;}
          .skio-atc.skio-atc--subscription.sunmed-atc-blocked .add-to-cart { color: #8a94ab;}
        </style>
      </fieldset>
    `;
  }

  willUpdate(changed) {
    // Set the key before rendering. If it changes after the radios exist, their
    // `name` changes and the browser unchecks the subscription radio.
    if (changed.has('product') && this.product && !this.key) {
      this.key = this.product.id;
    }
  }
  updated = (changed) => {
    if (changed.has('product') && this.product) {
      // this.key = this.key ? this.key : this.product.id;

      this.skioSellingPlanGroups = (this.product.selling_plan_groups || []).filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      );

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort((a,b) => {
          const an = parseInt(String(a.name).replace(/\D/g, ""), 10);
          const bn = parseInt(String(b.name).replace(/\D/g, ""), 10);
          return an - bn;
        });
      });

      if(window.__PRODUCT_VARIANT_METAFIELDS__) {
        for (const variantMetafields of window.__PRODUCT_VARIANT_METAFIELDS__) {
          let variant = this.product.variants.find(variant => String(variant.id) == variantMetafields.id);
          if(variant) {
            variant.metafields = variantMetafields;
          }
        }
      }
      
      this.selectedVariant = this.product.variants.find(variant => String(variant.id) == this.selectedVariant.id);
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      this.selectedVariant = this.product.variants.find(variant => String(variant.id) == this.selectedVariant.id);
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      );

      if (this.availableSellingPlanGroups?.length > 0) {
        this.availableSellingPlanGroups.forEach((group => {
          if (this.defaultFrequency) {
            const sp = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
            group.selected_selling_plan = sp || group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.purchaseOption == 'subscription') {
          if (!this.selectedSellingPlan) {
            const sellingPlanGroup = this.availableSellingPlanGroups[0];
            this.selectSellingPlanGroup(sellingPlanGroup);
          }
        } else {
          this.selectedSellingPlan = null;
          this.selectedSellingPlanGroup = null;
        }
	  } else {
        this.selectSellingPlanGroup();
      }

      if (!this.skioUiInitialized && this.availableSellingPlanGroups?.length > 0) {
        this.skioUiInitialized = true;
        this.selectSellingPlanGroup(this.availableSellingPlanGroups[0]);
      }

      this.updateForm();
      if (this.isIntialLoad) {
        if (!(changed.get('selectedVariant') === undefined) && !(changed.get('selectedVariant')?.metafields === undefined)) {
          this.isIntialLoad = false;
        }  
      } else {
        this.updateExternalPrice();
      }
    }

    if (changed.has('selectedSellingPlan')) {
      document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      this.updateForm();
      if (this.isIntialLoad) {
        if (!(changed.get('selectedSellingPlan') === undefined)) {
          this.isIntialLoad = false;
        }  
      } else {
        this.updateExternalPrice();
      }
      

      const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) sellingPlanInput.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : '';
    }

    if (changed.has('formId')) this.updateForm();
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    });
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency;
    });
    document.querySelectorAll(this.externalSaveSelector).forEach((el) => {
      let saveAmount = 0;
      if (this.selectedVariant.compare_at_price > this.selectedVariant.price) {
        saveAmount = this.selectedVariant.compare_at_price - this.selectedVariant.price;
      }
      if (this.selectedSellingPlan) saveAmount += this.discount(this.selectedSellingPlan).amount;
      if (saveAmount <= 0) return;
      el.innerHTML = 'Save ' + this.money(saveAmount);
    });
  }

  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    this.purchaseOption = group ? 'subscription' : 'onetime';
    this.updateForm();
  }

  selectSellingPlan(element, group) {
    const selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
      this.requestUpdate();
    }
  }

  money(price) {
    return this.moneyFormatter.format(price / 100.0);
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: '0%', amount: 0 };
    const price_adjustment = selling_plan.price_adjustments[0];
    const discount = { percent: '0%', amount: 0 };
    const price = this.selectedVariant.price;

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`;
        discount.amount = Math.round((price * price_adjustment.value) / 100.0);
        break;
      case 'fixed_amount':
        discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`;
        discount.amount = price_adjustment.value;
        break;
      case 'price':
        discount.percent = `${Math.round((((price - price_adjustment.value) * 1.0) / price) * 100.0)}%`;
        discount.amount = price - price_adjustment.value;
        break;
    }
    return discount;
  }

  price(selling_plan, formatted = true) {
    const v = this.selectedVariant.price - this.discount(selling_plan).amount;
    return formatted ? this.money(v) : v;
  }

  updateForm() {
    if (!this.formId) return;
    const form = document.querySelector(`#${this.formId}`);
    if (!form) return;

    let selling_plan_input = form.querySelector('[name="selling_plan"]');
    if (!selling_plan_input) {
      selling_plan_input = document.createElement('input');
      selling_plan_input.type = "hidden";
      selling_plan_input.name = "selling_plan";
      form.append(selling_plan_input);
    }
    selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : '';
    selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;

    let discount_input = form.querySelector('[name="properties[Discount]"]');
    if (!discount_input) {
      discount_input = document.createElement('input');
      discount_input.type = "hidden";
      discount_input.name = "properties[Discount]";
      form.append(discount_input);
    }
    discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : '';
    discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[0];
        return product;
      });
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);